import React from 'react'
import Admintable from '../Component/Admintable'

const Admin = () => {
  return (
    <>
        <Admintable />
    </>
  )
}

export default Admin
